import { put, takeLatest } from 'redux-saga/effects';

import * as workslotInsert from '../requests/workslot-insert-req';
import * as workslotUpdate from '../requests/workslot-update-req';
import * as blockslotInsert from '../requests/blockslot-insert-req';
import * as scheduleSearch from '../requests/schedule-search-req';
import * as workslotRemove from '../requests/workslot-remove-req';
import * as blockslotRemove from '../requests/blockslot-remove-req';
import * as blockslotUpdate from '../requests/blockslot-update-req';
import * as error from '../../ui/error';

function takeErrorConstants(target) {
  return [target.consts.ERROR_ENCOUNTERED, target.consts.REJECTED];
}

function* handleScheduleInsertError() {
  yield put(error.actions.update({ id: 'calendar.errors.insert.common' }));
}

function* handleScheduleRemoveError() {
  yield put(error.actions.update({ id: 'calendar.errors.remove.common' }));
}

function* handleScheduleSearchError() {
  yield put(error.actions.update({ id: 'calendar.errors.search.common' }));
}
function* handleScheduleUpdateError() {
  yield put(error.actions.update({ id: 'calendar.errors.update.common' }));
}

export default function* scheduleErrorHandlingSaga() {
  yield takeLatest(
    [
      ...takeErrorConstants(workslotInsert),
      ...takeErrorConstants(blockslotInsert),
    ],
    handleScheduleInsertError,
  );

  yield takeLatest(
    [
      ...takeErrorConstants(workslotRemove),
      ...takeErrorConstants(blockslotRemove),
    ],
    handleScheduleRemoveError,
  );

  yield takeLatest(
    takeErrorConstants(scheduleSearch),
    handleScheduleSearchError,
  );
  yield takeLatest(
    [
      ...takeErrorConstants(workslotUpdate),
      ...takeErrorConstants(blockslotUpdate),
    ],
    handleScheduleUpdateError,
  );
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/error-handling-saga.js